// Chakra Icons
import {BellIcon} from "@chakra-ui/icons";
// Chakra Imports
import {
    Avatar,
    Button,
    Flex,
    Box,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Text,
    Tooltip,
    useColorModeValue,
} from "@chakra-ui/react";
import {FILE_BASE_URL} from "constants/ApiConstant";
// Assets
import avatar1 from "assets/img/avatars/avatar1.png";
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar3 from "assets/img/avatars/avatar3.png";
// Custom Icons
import {SettingsIcon} from "components/Icons/Icons";
// Custom Components
import {ItemContent} from "components/Menu/ItemContent";
import SidebarResponsive from "components/Sidebar/SidebarResponsive";
import PropTypes from "prop-types";
import React from "react";
import {NavLink} from "react-router-dom";
import routes from "routes.js";
import schoolRoutes from "schoolRoutes.js";
import NepaliDateTime from "../NepaliDateTime/Index";
import LanguageToggle from "./LanguageToggle";
import OnlineStatusIndicator from "./OnlineStatusIndicator";

export default function HeaderLinks(props) {
    const {variant, children, fixed, secondary, onOpen, ...rest} = props;

    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const menuRoutes = props.menuRoutes || (
        userInfo?.roleCode === "SUPER_ADMIN" ? routes : schoolRoutes
    );
    const isSchoolDashboard = menuRoutes === schoolRoutes;

    // Chakra Color Mode
    let navbarIcon = useColorModeValue("gray.500", "gray.200");
    const clientNameColor = useColorModeValue("gray.700", "white");
    const userNameColor = useColorModeValue("gray.500", "gray.400");
    const profileHoverBg = useColorModeValue("gray.100", "whiteAlpha.200");

    if (secondary) {
        navbarIcon = "white";
    }

    // The client/school logo lives on userInfo as a stored file path (same as
    // the school setup rows). Resolve absolute URLs as-is and prefix relative
    // paths with FILE_BASE_URL; falls back to Avatar initials when absent.
    const rawLogo = userInfo?.clientLogo || userInfo?.schoolLogo || userInfo?.logo;
    const clientLogo = rawLogo
        ? (rawLogo.startsWith("http") ? rawLogo : `${FILE_BASE_URL}${rawLogo}`)
        : undefined;
    const clientName = userInfo?.clientName || userInfo?.schoolName || "";
    const userName = userInfo?.fullName || "N/A";

    const settingsRef = React.useRef();
    return (
        <Flex
            pe={{base: "0px", xl: "16px"}}
            w="auto"
            alignItems="center"
            flexDirection="row"
            justifyContent="flex-end"
            gap={{base: "4px", md: "8px", xl: "12px"}}
        >
            {/*<InputGroup*/}
            {/*    cursor="pointer"*/}
            {/*    bg={inputBg}*/}
            {/*    borderRadius="15px"*/}
            {/*    w={{*/}
            {/*        sm: "128px",*/}
            {/*        md: "200px",*/}
            {/*    }}*/}
            {/*    me={{sm: "auto", md: "20px"}}*/}
            {/*    _focus={{*/}
            {/*        borderColor: {mainTeal},*/}
            {/*    }}*/}
            {/*    _active={{*/}
            {/*        borderColor: {mainTeal},*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <InputLeftElement*/}
            {/*        children={*/}
            {/*        }*/}
            {/*    />*/}
            {/*    */}
            {/*</InputGroup>*/}

            {isSchoolDashboard && <OnlineStatusIndicator secondary={secondary}/>}
            <LanguageToggle secondary={secondary}/>
            <Box display={{base: "none", lg: "block"}}>
                <NepaliDateTime/>
            </Box>
            <SidebarResponsive
                logoText={props.logoText}
                secondary={props.secondary}
                routes={menuRoutes}
                {...rest}
            />
            {/*<NavLink to="/auth/signin">*/}
            <NavLink to={"#"} style={{display: "flex"}}>
                <Flex
                    align="center"
                    gap="10px"
                    py="4px"
                    px={{base: "4px", md: "8px"}}
                    borderRadius="14px"
                    transition="all 0.2s ease"
                    cursor="pointer"
                    _hover={{bg: profileHoverBg}}
                >
                    <Avatar
                        src={clientLogo}
                        name={clientName || userName}
                        size="sm"
                        borderRadius="full"
                        bg="teal.400"
                        color="white"
                        boxShadow="0 0 0 2px rgba(56, 178, 172, 0.25)"
                    />
                    <Box
                        display={{base: "none", lg: "block"}}
                        textAlign="left"
                        lineHeight="1.25"
                        minW="0"
                        maxW={{lg: "180px", xl: "260px", "2xl": "340px"}}
                    >
                        <Tooltip label={clientName || userName} placement="bottom" hasArrow openDelay={400}>
                            <Text
                                fontSize="sm"
                                fontWeight="bold"
                                color={clientNameColor}
                                noOfLines={2}
                                whiteSpace="normal"
                                wordBreak="break-word"
                            >
                                {clientName || userName}
                            </Text>
                        </Tooltip>
                        {clientName && (
                            <Text
                                fontSize="xs"
                                fontWeight="normal"
                                color={userNameColor}
                                noOfLines={1}
                            >
                                {userName}
                            </Text>
                        )}
                    </Box>
                </Flex>
            </NavLink>
            <SettingsIcon
                display={{base: "none", md: "block"}}
                cursor="pointer"
                ms="0px"
                me="0px"
                ref={settingsRef}
                onClick={props.onOpen}
                color={navbarIcon}
                w="18px"
                h="18px"
            />
            <Menu>
                <MenuButton display={{base: "none", md: "block"}}>
                    <BellIcon color={navbarIcon} w="18px" h="18px"/>
                </MenuButton>
                <MenuList p="16px 8px">
                    <Flex flexDirection="column">
                        <MenuItem borderRadius="8px" mb="10px">
                            <ItemContent
                                time="13 minutes ago"
                                info="from Alicia"
                                boldInfo="New Message"
                                aName="Alicia"
                                aSrc={avatar1}
                            />
                        </MenuItem>
                        <MenuItem borderRadius="8px" mb="10px">
                            <ItemContent
                                time="2 days ago"
                                info="by Josh Henry"
                                boldInfo="New Album"
                                aName="Josh Henry"
                                aSrc={avatar2}
                            />
                        </MenuItem>
                        <MenuItem borderRadius="8px">
                            <ItemContent
                                time="3 days ago"
                                info="Payment succesfully completed!"
                                boldInfo=""
                                aName="Kara"
                                aSrc={avatar3}
                            />
                        </MenuItem>
                    </Flex>
                </MenuList>
            </Menu>
        </Flex>
    );
}

HeaderLinks.propTypes = {
    variant: PropTypes.string,
    fixed: PropTypes.bool,
    secondary: PropTypes.bool,
    onOpen: PropTypes.func,
};
